import NotFound from "@/src/NotFound";
import UnexpectedError from "@/src/UnexpectedError";
import AppAssessmentResult from "@/src/app/(auth)/assessment-result/page";
import Category from "@/src/app/(auth)/assessment/categories/[id]/page";
import SubCategory from "@/src/app/(auth)/assessment/categories/[id]/sub-categories/[sid]/page";
import Assessment from "@/src/app/(auth)/assessment/page";
import AppCertificate from "@/src/app/(auth)/certificate/page";
import History from "@/src/app/(auth)/history/page";
import AppImprovementProposal from "@/src/app/(auth)/improvement-proposal/page";
import AppLayout from "@/src/app/(auth)/layout";
import EditProfile from "@/src/app/(auth)/profile/edit/page";
import Profile from "@/src/app/(auth)/profile/page";
import AppLogin from "@/src/app/login/page";
import AppNotFound from "@/src/app/not-found/page";
import AllAssessments from "@/src/console/(auth)/(check-assessments)/all-assessments/page";
import SubmissionCategoryDetail from "@/src/console/(auth)/(check-assessments)/check-submissions/[id]/categories/[id]/page";
import SubmissionSubCategoryDetail from "@/src/console/(auth)/(check-assessments)/check-submissions/[id]/categories/[id]/sub-categories/[id]/page";
import EvaluateReport from "@/src/console/(auth)/(check-assessments)/check-submissions/[id]/evaluate/page";
import CheckSubmissionDetail from "@/src/console/(auth)/(check-assessments)/check-submissions/[id]/page";
import ImprovementProposal from "@/src/console/(auth)/(check-assessments)/check-submissions/[id]/proposal/page";
import CheckSubmissions from "@/src/console/(auth)/(check-assessments)/check-submissions/page";
import ReAssessmentCategoryDetail from "@/src/console/(auth)/(check-assessments)/re-assessments/[id]/categories/[id]/page";
import ReAssessmentSubCategoryDetail from "@/src/console/(auth)/(check-assessments)/re-assessments/[id]/categories/[id]/sub-categories/[id]/page";
import ReAssessmentEvaluationPage from "@/src/console/(auth)/(check-assessments)/re-assessments/[id]/evaluate/page";
import ReAssessmentDetail from "@/src/console/(auth)/(check-assessments)/re-assessments/[id]/page";
import Reassessments from "@/src/console/(auth)/(check-assessments)/re-assessments/page";
import ConfirmAssessments from "@/src/console/(auth)/(confirm-assessments)/assessments/page";
import ConfirmReAssessments from "@/src/console/(auth)/(confirm-assessments)/re-assessments/page";
import RegularAssessmentCreate from "@/src/console/(auth)/(manage-assessments)/regular-assessments/create/page";
import RegularAssessments from "@/src/console/(auth)/(manage-assessments)/regular-assessments/page";
import SimpleAssessmentCreate from "@/src/console/(auth)/(manage-assessments)/simple-assessments/create/page";
import SimpleAssessments from "@/src/console/(auth)/(manage-assessments)/simple-assessments/page";
import ConsoleAssessmentResult from "@/src/console/(auth)/assessment-results/[id]/page";
import Assessors from "@/src/console/(auth)/assessors/page";
import ConsoleCertificate from "@/src/console/(auth)/certificates/page";
import CertificationDetail from "@/src/console/(auth)/certifications/[id]/page";
import Certifications from "@/src/console/(auth)/certifications/page";
import CompanyEdit from "@/src/console/(auth)/companies/[id]/edit/page";
import CompanyView from "@/src/console/(auth)/companies/[id]/page";
import CompanyNew from "@/src/console/(auth)/companies/new/page";
import Companies from "@/src/console/(auth)/companies/page";
import ConsoleImprovementProposal from "@/src/console/(auth)/improvement-proposals/[id]/page";
import ConsoleLayout from "@/src/console/(auth)/layout";
import ConsoleLogin from "@/src/console/login/page";
import ConsoleNotFound from "@/src/console/not-found/page";
import FreeCertificatePage from "@/src/free-assessment/certificate/page";
import Info from "@/src/free-assessment/info/page";
import FreeAssessmentLayout from "@/src/free-assessment/layout";
import Overview from "@/src/free-assessment/overview/page";
import Questions from "@/src/free-assessment/questions/page";
import Result from "@/src/free-assessment/result/page";
import RegisterCompanyPage from "@/src/register-company/page";
import Root from "@/src/root";
import { createBrowserRouter, redirect } from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    Component: Root,
    ErrorBoundary: UnexpectedError,
    children: [
      {
        index: true,
        loader: () => redirect("register-company"),
      },
      {
        path: "register-company",
        Component: RegisterCompanyPage,
      },
      {
        path: "*",
        Component: NotFound,
      },
      {
        path: "/unexpected-error",
        Component: UnexpectedError,
      },
      {
        id: "free-assessment",
        Component: FreeAssessmentLayout,
        children: [
          {
            path: "free-assessment/info",
            Component: Info,
          },
          {
            path: "free-assessment/overview",
            Component: Overview,
          },
          {
            path: "free-assessment/questions",
            Component: Questions,
          },
          {
            path: "free-assessment/result",
            Component: Result,
          },
          {
            path: "free-assessment/certificate",
            Component: FreeCertificatePage,
          },
        ],
      },
      {
        path: "app/login",
        Component: AppLogin,
      },
      {
        id: "app",
        Component: AppLayout,
        children: [
          {
            path: "app/*",
            Component: AppNotFound,
          },
          {
            path: "app/assessment",
            Component: Assessment,
          },
          {
            path: "app/assessment/categories/:categoryId",
            Component: Category,
          },
          {
            path: "app/assessment/categories/:categoryId/sub-categories/:subCategoryId",
            Component: SubCategory,
          },
          {
            path: "app/history",
            Component: History,
          },
          {
            path: "app/profile",
            Component: Profile,
          },
          {
            path: "app/profile/edit",
            Component: EditProfile,
          },
          {
            path: "app/assessment-results/:id",
            Component: AppAssessmentResult,
          },
          {
            path: "app/improvement-proposals/:id",
            Component: AppImprovementProposal,
          },
          {
            path: "app/certificate",
            Component: AppCertificate,
          },
        ],
      },
      {
        path: "console/login",
        Component: ConsoleLogin,
      },
      {
        id: "console",
        Component: ConsoleLayout,
        children: [
          {
            path: "console/*",
            Component: ConsoleNotFound,
          },
          {
            path: "console/all-assessments",
            Component: AllAssessments,
          },
          {
            path: "console/check-submissions/",
            Component: CheckSubmissions,
          },
          {
            path: "console/check-submissions/:id",
            Component: CheckSubmissionDetail,
          },
          {
            path: "console/check-submissions/:id/categories/:categoryId",
            Component: SubmissionCategoryDetail,
          },
          {
            path: "console/check-submissions/:id/categories/:categoryId/sub-categories/:subCategoryId",
            Component: SubmissionSubCategoryDetail,
          },
          {
            path: "console/check-submissions/:id/evaluate",
            Component: EvaluateReport,
          },
          {
            path: "console/check-submissions/:id/proposal",
            Component: ImprovementProposal,
          },
          {
            path: "console/re-assessments",
            Component: Reassessments,
          },
          {
            path: "console/re-assessments/:id",
            Component: ReAssessmentDetail,
          },
          {
            path: "console/re-assessments/:id/categories/:categoryId",
            Component: ReAssessmentCategoryDetail,
          },
          {
            path: "console/re-assessments/:id/categories/:categoryId/sub-categories/:subCategoryId",
            Component: ReAssessmentSubCategoryDetail,
          },
          {
            path: "console/re-assessments/:id/evaluate",
            Component: ReAssessmentEvaluationPage,
          },
          {
            path: "console/confirm-assessments",
            Component: ConfirmAssessments,
          },
          {
            path: "console/confirm-re-assessments",
            Component: ConfirmReAssessments,
          },
          {
            path: "console/certifications",
            Component: Certifications,
          },
          {
            path: "console/certifications/:id",
            Component: CertificationDetail,
          },
          {
            path: "console/companies",
            Component: Companies,
          },
          {
            path: "console/companies/:id",
            Component: CompanyView,
          },
          {
            path: "console/companies/:id/edit",
            Component: CompanyEdit,
          },
          {
            path: "console/companies/new",
            Component: CompanyNew,
          },
          {
            path: "console/regular-assessments/create",
            Component: RegularAssessmentCreate,
          },
          {
            path: "console/regular-assessments",
            Component: RegularAssessments,
          },
          {
            path: "console/simple-assessments/create",
            Component: SimpleAssessmentCreate,
          },
          {
            path: "console/simple-assessments",
            Component: SimpleAssessments,
          },
          {
            path: "console/assessors",
            Component: Assessors,
          },
        ],
      },
      {
        path: "console/assessment-results/:id",
        Component: ConsoleAssessmentResult,
      },
      {
        path: "console/improvement-proposals/:id",
        Component: ConsoleImprovementProposal,
      },
      {
        path: "console/certificates/:id",
        Component: ConsoleCertificate,
      },
    ],
  },
]);

export default router;
